import React from 'react';
import {
  Button,
  Space,
  Tooltip,
} from 'antd';
import {
  PhoneOutlined,
  PhoneFilled,
  AudioOutlined,
  CustomerServiceOutlined,
} from '@ant-design/icons';

/**
 * CallControlButtons Component
 * Reusable call control buttons for start/end call and mute/speaker controls
 * 
 * Props:
 * - isCalling: boolean - Whether a call is currently active
 * - onStartCall: function - Called when start call button is clicked
 * - onEndCall: function - Called when end call button is clicked
 * - onToggleMute: function - Called when mute button is clicked
 * - onToggleSpeaker: function - Called when speaker button is clicked
 * - loading: boolean - Show loading state on start call button
 * - disabled: boolean - Disable all buttons
 */
const CallControlButtons = ({
  isCalling,
  onStartCall,
  onEndCall,
  onToggleMute,
  onToggleSpeaker,
  loading = false,
  disabled = false,
}) => {
  if (isCalling) {
    return (
      <Space>
        <Tooltip title="End Call">
          <Button
            danger
            type="primary"
            icon={<PhoneFilled />}
            onClick={onEndCall}
            disabled={disabled}
          >
            End Call
          </Button>
        </Tooltip>
        <Tooltip title="Mute/Unmute">
          <Button
            icon={<AudioOutlined />}
            onClick={onToggleMute}
            disabled={disabled}
          >
            Mute
          </Button>
        </Tooltip>
        <Tooltip title="Toggle Speaker">
          <Button
            icon={<CustomerServiceOutlined />}
            onClick={onToggleSpeaker}
            disabled={disabled}
          >
            Speaker
          </Button>
        </Tooltip>
      </Space>
    );
  }

  return (
    <Tooltip title="Start Manual Call">
      <Button
        type="primary"
        icon={<PhoneOutlined />}
        onClick={onStartCall}
        loading={loading}
        disabled={disabled}
        block
        style={{ width: '100%' }}
      >
        Start Call
      </Button>
    </Tooltip>
  );
};

export default CallControlButtons;
